const doc = [({"en":({"js":({"admin":({"contact_relationships":({"edit":({"new_relationship":"New relationship", "edit_relationship":"Edit relationship"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;